export default __webpack_public_path__ + "static/media/logo_reforma.5604a966.svg";